import * as React from 'react';
import * as Glob from '../Globale';
import * as Dati from '../Dati';
import { ChiamaAPI, Bottone, Trad, Paginatore, Tipo, BasePureDeroga, BottoneAPI } from '../components/';
import { Layout } from '../layout/Layout';
import $ from 'jquery';
import "datatables.net-bs4";
import "datatables.net-responsive-bs4";
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';

interface IDerogaListaState {
    Caricamento: boolean;
    Aggiornare: number;
    Dati?: Dati.CRisAPIPagineDeroga;
    MotivoDeroga: string;
    ParamAPIPagine: Dati.CParamAPIPagine;
    ParametriUtente: Dati.TListaParametri; //Salvati qui e trasferiti in Parametri quando l'utente clicca "Cerca"
    Parametri: Dati.TListaParametri;
}

export class DerogaLista extends BasePureDeroga<Glob.IRouteGlobaleProps, IDerogaListaState> {

    private ParametriFissi: Dati.TListaParametri = {};

    Tabella: any = null;
    TabellaOrdinamento: [number, string] = [1, 'asc'];
    TabellaAggiorna: number = 0;

    private AttivaTabella() {
        if (this.TabellaAggiorna != this.state.Aggiornare) {
            this.TabellaAggiorna = this.state.Aggiornare;
            if (this.state.Dati != undefined) {
                let T: any = $(this.refs.tabella);

                this.Tabella = T.DataTable({
                    responsive: true,
                    paging: false,
                    searching: false,
                    info: false,
                    ordering: true,
                    destroy: true,
                    order: this.TabellaOrdinamento,
                    columnDefs: [
                        {
                            targets: [3, 5, 6], orderable: false
                        }
                    ]
                });

                T.one('order.dt', (e: any, settings: any) => {
                    let TO: any = this.Tabella.order();
                    if (TO != undefined && TO[0] != undefined) {
                        this.TabellaOrdinamento[1] = TO[0][1];
                        this.TabellaOrdinamento[0] = TO[0][0];
                        switch (this.TabellaOrdinamento[0]) {
                            case 0:
                                this.OnOrdinamento("ID_Deroga", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 1:
                                this.OnOrdinamento("Tipo", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 2:
                                this.OnOrdinamento("Stato", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                            case 4:
                                this.OnOrdinamento("Creato", this.TabellaOrdinamento[1].toUpperCase())
                                break;
                        }
                    }
                });
            }
        }
    }

    public componentDidMount() {
        this.AttivaTabella();
    }

    public componentDidUpdate() {
        this.AttivaTabella();
    }

    public constructor(props: any) {
        super(props);
        let Param: Dati.CParamAPIPagine = new Dati.CParamAPIPagine();
        Param.Sessione = Glob.GetSessione().Sessione;
        Param.Numero = 10;
        Param.Pagina = 1;
        this.state = { Aggiornare: 1, Caricamento: true, ParamAPIPagine: Param, Dati: undefined, MotivoDeroga: "", Parametri: this.ParametriFissi, ParametriUtente: {} };
        this.OnInvio = this.OnInvio.bind(this);
        //this.OnRis = this.OnRis.bind(this);
        this.OnErroreLista = this.OnErroreLista.bind(this);
        this.OnCambioPagina = this.OnCambioPagina.bind(this);
        this.OnChange = this.OnChange.bind(this);
    }

    private OnInvio(sender: ChiamaAPI) {
        return this.UnisciListaParametri(this.state.Parametri, this.ParametriFissi);
    }

    private RestituisciIcona(tipo: string) {
        switch (tipo) {
            case Glob.Tipi_DT_Polizza:
                return "fa fa-file";
            case Glob.Tipi_DT_Fideiussione:
                return "fa fa-pencil-alt";
            default:
                return "fa fa-file";
        }
    }

    private RestituisciSfondo(stato: string): string {
        switch (stato) {
            case Glob.Tipi_DR_Approvata:
                return "verde";
            case Glob.Tipi_DR_Rifiutata:
                return "rosso";
            default:
                return "";
        }
    }

    private OnRis(sender: ChiamaAPI, dati: Dati.CRisAPIPagineDeroga, datiNuovi: boolean): React.ReactNode {
        if (datiNuovi) {
            this.TabellaAggiorna = 0;
            if (this.Tabella != null) {
                this.Tabella.destroy();
            }
            this.setState({ Dati: dati, Caricamento: false }, () => this.AttivaTabella());
        }
        if (dati.Errore) {
            return false;
        }
        if (dati.Dati.length == 0) {
            return <tbody><tr>
                <td colSpan={7} className="TextLeft alert-warning">
                    <div className="kt-alert__icon">
                        <i className="fa fa-exclamation-triangle"> </i>
                        <span>{Trad.Trad("Nessun record corrisponde ai parametri di ricerca")}</span>
                    </div>
                </td>
            </tr></tbody>;
        }
        else {
            return true;
        }
    }

    private OnErroreLista(sender: ChiamaAPI, errore: Error) {
        this.setState({ Caricamento: false });
        return <tbody><tr><td colSpan={7}>{Trad.Trad("ListaErrore")}</td></tr></tbody>;
    }

    private OnCambioPagina(sender: Paginatore, pagina: number) {
        this.state.ParamAPIPagine.Pagina = pagina;
        this.setState({ ParamAPIPagine: this.state.ParamAPIPagine, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    private OnOrdinamento(Campo: string, Verso: string) {
        this.state.Parametri["OrdinaCampo"] = Campo;
        this.state.Parametri["OrdinaVerso"] = Verso;
        this.setState({ Parametri: this.state.Parametri, Aggiornare: this.state.Aggiornare + 1, Caricamento: true });
    }

    private OnInvioDeroga(sender: BottoneAPI, i: number, stato: string): any {
        if (this.state.Dati != undefined) {
            let invio = this.state.Dati.Dati[i];
            invio.Note = this.state.MotivoDeroga;
            invio.ID_TipoDerogaStato = stato
            this.setState({ MotivoDeroga: "" });
            return invio;
        } else {
            this.setState({ MotivoDeroga: "" });
            return false;
        }
    }

    private OnInvioUrl(sender: BottoneAPI, i: number, stato: string): any {
        return true;
    }

    private OnClickDeroga(sender: BottoneAPI, dati: Dati.CRisAPI) {
        if (dati.Errore) {
            Glob.InfoModaleError(Trad.Trad("ERRORE"), dati.ErrTesto);
        }
        else {
            Glob.InfoModaleSuccess(Trad.Trad("DEROGA"), "Richiesta cambio stato avvenuto con successo");
            this.setState({ Aggiornare: this.state.Aggiornare + 1 });
        }
    }

    protected OnChangeMotivoDeroga(e: React.FormEvent<any>): any {
        this.setState({ MotivoDeroga: e.currentTarget.value })
    }

    OnChiaveStringUpdate(keyValue: any, key: string) {
        const newValue = Object.assign({}, this.state.ParametriUtente);
        newValue[key] = keyValue;
        this.setState({ParametriUtente: newValue});
    }

    public render() {

        let AccordionAperto: string = "collapse in";

        let dati: any[] = [];
        if (this.state.Dati != undefined && this.state.Dati.Dati != undefined) {
            {
                for (let i: number = 0; i < this.state.Dati.Dati.length; i++) {
                    let datiDeroga: any = JSON.parse(this.state.Dati.Dati[i].DerogaJSON);
                    let visDati: any[] = [];
                    for (let key in datiDeroga) {
                        visDati.push(this.CampoNew(key, datiDeroga[key].Tipo, datiDeroga));
                    }
                    dati.push(<tr data-row={i} key={i} className={this.RestituisciSfondo(this.state.Dati.Dati[i].ID_TipoDerogaStato)}>
                        <td data-field="ID_Deroga" className="TextCenter">
                            <BottoneAPI Default={false} URL={"/api/Url/GetURL?template=" + Layout.GetTemplateUrl(this.state.Dati.Dati[i].ID_TipoDerogaTipo) + "&tipo=" + this.state.Dati.Dati[i].ID_TipoDerogaTipo + "&chiave=" + this.state.Dati.Dati[i].ID_Deroga} Metodo="GET" OnClick={(s, d) => Layout.OnClickUrl(s, d, this.props.history)} OnErrore={(s, e) => this.OnErrore(s, e)} Visibile={this._Lettura} ClasseAttivo="bottoneTesto" ClasseAttesa="bottoneTesto" Testo={this.state.Dati.Dati[i].ID_Deroga.toString()} Icona="" />
                        </td>
                        <td data-field="Tipo" className="TextLeft">{Trad.Trad(this.state.Dati.Dati[i].Tipo)}</td>
                        <td data-field="Stato" className="TextLeft">{Trad.Trad(this.state.Dati.Dati[i].Stato)}</td>
                        <td data-field="Stato" className="TextLeft">{this.state.Dati.Dati[i].Note}</td>
                        <td data-field="Data" className="TextCenter">{this.state.Dati.Dati[i].Creato.toLocaleDateString()}</td>
                        <td data-field="Dati" className="TextCenter">
                            <h5 className="kt-portlet__head-label">
                                <a data-toggle="collapse" href={"#datideroga" + i} aria-expanded="true" className="arrow"><i className="fa fa-search"></i></a>
                            </h5>
                            <div className={AccordionAperto} id={"datideroga" + i}>
                                {visDati}
                            </div>
                        </td>
                        <td data-field="Azioni" className="TextCenter">
                            {!this.state.Dati.Dati[i].Elaborata &&
                                <div className="divtabella">
                                    <button type="button" className="btn btn-metal kt-btn kt-btn--icon btn--icon-only" data-toggle="modal" data-target={"#kt_modal_" + i} title={Trad.Trad("Modifica")} disabled={!this.state.Dati.Dati[i].Abilitato}><i className="fa fa-hand-pointer"></i></button>
                                </div>
                            }
                            {!this.state.Dati.Dati[i].Elaborata &&
                                <div className="modal fade" id={"kt_modal_" + i} role="dialog" aria-labelledby="modalCartaServizi">
                                    <div className="modal-dialog modal-dialog-centered" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header alert-info">
                                                <h5 className="modal-title" id="derogaModalLongTitle">{Trad.Trad("DEROGA")}</h5>
                                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                                    <span aria-hidden="true">×</span>
                                                </button>
                                            </div>
                                            <div className="modal-body col-lg-12">
                                                <div className="form-group kt-form login-form__group row">
                                                <textarea className="form-control" name="MotivoDeroga" id="MotivoDeroga" value={this.state.MotivoDeroga} onChange={(e) => this.OnChangeMotivoDeroga(e)} rows={4} />
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-secondary" data-dismiss="modal">{Trad.Trad("Chiudi")}</button>
                                            <BottoneAPI Default={false} URL="/api/Deroga/AggiornaStato" Metodo="POST" OnInvio={(s) => this.OnInvioDeroga(s, i, Glob.Tipi_DR_Approvata)} OnClick={(s, d) => this.OnClickDeroga(s, d)} OnErrore={(s, e) => this.OnErrore(s, e)} Visibile={this._Scrittura} ClasseAttivo="btn btn-success kt-btn kt-btn--icon" Testo={Trad.Trad("Approva")} DataDismiss="modal" />
                                            <BottoneAPI Default={false} URL="/api/Deroga/AggiornaStato" Metodo="POST" OnInvio={(s) => this.OnInvioDeroga(s, i, Glob.Tipi_DR_Passa)} OnClick={(s, d) => this.OnClickDeroga(s, d)} OnErrore={(s, e) => this.OnErrore(s, e)} Visibile={this._Scrittura} ClasseAttivo="btn btn-warning kt-btn kt-btn--icon" Testo={Trad.Trad("LevelUP")} DataDismiss="modal" />
                                            <BottoneAPI Default={false} URL="/api/Deroga/AggiornaStato" Metodo="POST" OnInvio={(s) => this.OnInvioDeroga(s, i, Glob.Tipi_DR_Rifiutata)} OnClick={(s, d) => this.OnClickDeroga(s, d)} OnErrore={(s, e) => this.OnErrore(s, e)} Visibile={this._Scrittura} ClasseAttivo="btn btn-danger square-button-with-icon kt-btn kt-btn--icon" Testo={Trad.Trad("Rifiuta")} DataDismiss="modal" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {!this.state.Dati.Dati[i].Elaborata ||
                                <div className="divtabella">
                                    <i className="fa fa-check"></i>
                                </div>
                            }
                        </td>
                    </tr>);
                }
            }
        }
        return <div className="kt-portlet">
            <div className="kt-portlet__head">
                <div className="kt-portlet__head-label">
                    <div className="kt-portlet__head-label">
                        <span className="kt-portlet__head-icon">
                            <i className="fa fa-hand-pointer"></i>
                        </span>
                        <h3 className="kt-portlet__head-label">
                            {Trad.Trad("Deroghe")}</h3>
                    </div>
                </div>
            </div>
            <form className="kt-form vertical-form kt-form login-form--fit kt-form login-form--label-align-right kt-form login-form--group-seperator-dashed">
                <div className="kt-portlet__body">
                    <div className="form-group kt-form login-form__group row">
                        <label className="col-lg-1 col-form-label">{Trad.Trad("ID")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <input onChange={(e) => this.OnChange(e)} type="text" value={this.state.ParametriUtente["ID_Deroga"] || ""} name="ParametriUtente[ID_Deroga]" className="form-control kt-input" />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Tipo Deroga")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <Tipo Campo="ParametriUtente[ID_TipoDerogaTipo]" ID_ChiaveString={this.state.ParametriUtente["ID_TipoDerogaTipo"] || ""} OnAggiorna={(e,v) => {this.OnChange(e, v);  this.OnChiaveStringUpdate(v, "ID_TipoDerogaTipo")}} URL="/api/Tipi/ListaTipi?ID_TipoContesto=DerogaTipo" />
                        </div>
                        <label className="col-lg-1 col-form-label">{Trad.Trad("Stato Deroga")}</label>
                        <div className="col-lg-3 form-control-plaintext">
                            <div className="kt-input-icon kt-input-icon--right">
                                <Tipo IgnoraPermessi Campo="ParametriUtente[ID_TipoDerogaStato]" ID_ChiaveString={this.state.ParametriUtente["ID_TipoDerogaStato"]} OnAggiorna={(e,v) => {this.OnChange(e, v);  this.OnChiaveStringUpdate(v, "ID_TipoDerogaStato")}} URL="/api/Tipi/ListaTipi?ID_TipoContesto=DerogaStato" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="kt-portlet__foot kt-portlet__foot--fit">
                    <div className="kt-form login-form__actions kt-form login-form__actions--middle">
                        <div className="row">
                            <div className="col-lg-12 kt-form__actions kt-form__actions--center">
                                <Bottone Default Attesa={this.state.Caricamento} OnClick={(e) => { this.state.ParamAPIPagine.Pagina = 1; this.setState({ Parametri: this.CopiaListaParametri(this.state.ParametriUtente, true), ParamAPIPagine: this.state.ParamAPIPagine, Caricamento: true, Aggiornare: this.state.Aggiornare + 1 }) }} Testo={Trad.Trad("Cerca")} />
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <Paginatore Pagina={this.state.ParamAPIPagine.Pagina} Pagine={this.state.Dati == undefined ? 0 : this.state.Dati.Pagine} OnCambioPagina={this.OnCambioPagina} />
            <div>
                <table className="table table-hover dtr-inline dataTable" id="tabella" ref="tabella">
                    <thead>
                        <tr className="sfondoTab">
                            <th data-field="ID_Deroga" className="TextCenter">ID</th>
                            <th data-field="Tipo" className="TextLeft">{Trad.Trad("Tipo")}</th>
                            <th data-field="Stato" className="TextLeft">{Trad.Trad("Stato")}</th>
                            <th data-field="Oggetto" className="TextLeft">{Trad.Trad("Note deroga")}</th>
                            <th data-field="Data" className="TextCenter">{Trad.Trad("Data")}</th>
                            <th data-field="Dati" className="TextCenter">{Trad.Trad("Dati deroga")}</th>
                            <th data-field="Operazione" className="TextCenter">{Trad.Trad("Operazione")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dati}
                    </tbody>
                    <ChiamaAPI Aggiornare={this.state.Aggiornare} URL="/api/deroga/ricerca" ParamURLClasse={this.state.ParamAPIPagine} OnInvio={this.OnInvio} OnRis={(s, d, dn) => this.OnRis(s, d, dn)} OnErrore={this.OnErroreLista} />
                </table>
            </div>
        </div >;
    }
}



// WEBPACK FOOTER //
// ./src/form/DerogaLista.tsx